import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { sidePanelYesNoAnswers } from 'app/modules/grant-review/constants/side-panel-answers.const';

@Component({
  selector: 'app-site-visit-service-delivery',
  templateUrl: './site-visit-service-delivery.component.html',
  styleUrls: ['./site-visit-service-delivery.component.scss']
})
export class SiteVisitServiceDeliveryComponent implements OnInit {

  theme: 'dark' | 'light' = 'light';
  style: 'default' | 'bordered' = 'default';

  @Input() siteVisitServiceDeliveryForm: FormGroup;
  @Input() isReadOnly: boolean;

  siteVisitServiceDeliveryAnswers = sidePanelYesNoAnswers;

  constructor() { }

  ngOnInit() {
  }

}
